/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import Close from "@material-ui/icons/Close";
import { useI18n } from "hooks/i18n/i18n";

import {
  headerStyle,
  modalCloseButtonStyle,
  modalCloseIconStyle,
  titleStyle,
} from "./styles";

import type { FcWithoutChildren } from "types/fcWithoutChildren";

type Props = {
  onClose: () => void;
};

export const Header: FcWithoutChildren<Props> = (props) => {
  const { onClose } = props;
  const { t } = useI18n();

  return (
    <header css={headerStyle}>
      <h2 css={titleStyle}>{t("search.searchModal.header.title")}</h2>
      <button
        type="button"
        aria-label={t("search.searchModal.header.close")}
        onClick={onClose}
        css={modalCloseButtonStyle}
      >
        <Close css={modalCloseIconStyle} />
      </button>
    </header>
  );
};
